import HelpIcon from "@mui/icons-material/HelpOutline";
import { Tooltip, TooltipProps } from "@mui/material";
import { ReactNode } from "react";

const Help = ({ text, placement = "top", slotProps }: { placement?: TooltipProps["placement"], text: ReactNode, slotProps?: TooltipProps["slotProps"] }) => {
  return <Tooltip placement={placement} title={text} slotProps={slotProps}>
    <HelpIcon fontSize={"small"} sx={{ ml: 0.5 }} color="primary" />
  </Tooltip>
}

export default Help
